var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __values = (this && this.__values) || function (o) {
    var m = typeof Symbol === "function" && o[Symbol.iterator], i = 0;
    if (m) return m.call(o);
    return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
};
import { action, observable, computed } from "mobx";
import { createTransformer } from "mobx-utils";
import { PulseBetMarketAdditionalData, ProgressStatus, WinningDataInner, Parser, PulseBetProgressData, PulseBetProgressPeriodData, CalculatedPeriodHelper } from "../../../data";
import { PlayByPlayIncidentTypes, GameStatuses } from "./enums";
import { MasterEventModel } from "./MasterEventModel";
import { PulseBetsTypes } from "../../../data/enums";
import { statusModifier } from "../helpers";
import { OpenPulseBetViewModel } from "./models";
import { EventsManager } from "sb-js-extends";
var MyPulseBetsData = /** @class */ (function () {
    function MyPulseBetsData(provider, oddsUtil, dict, cmsConfig) {
        var _this = this;
        /*istanbul ignore next */
        this.hasAnyOpenPulseBets = createTransformer(function (eventTypeId) {
            return _this.openViewModels.some(function (openBet) { return openBet.pulseBetMetadata.typeId === eventTypeId; });
        });
        /*istanbul ignore next */
        this.getOpenPulseBets = createTransformer(function (eventTypeId) {
            return _this.openViewModels.filter(function (openBet) { return openBet.pulseBetMetadata.typeId === eventTypeId; });
        });
        this.name = "MyPulseBetsData";
        this.provider = provider;
        this.userInfo = provider.userInfo;
        this.eventsManager = new EventsManager();
        this.oddsUtil = oddsUtil;
        this.dict = dict;
        this.calculatedPeriodHelperDependency = CalculatedPeriodHelper.getInstance();
        this.userInfo.onLogin[this.name] = this.onLogin;
        this.userInfo.onLogout[this.name] = this.onLogout;
        this.userInfo.current ? this.onLogin() : this.onLogout();
        this.openViewModels = [];
        this.pulseBetTypes = this.getPulseBetTypes();
        this.durationInMili = cmsConfig.durationInMili;
        this.updateOpenBetsInterval = cmsConfig.updateOpenBetsInterval;
        this.trackColor = cmsConfig.trackColor;
        this.openMyPulseBetsDelay = cmsConfig.openMyPulseBetsDelay;
        this.removePulseInterval = cmsConfig.removeBetIntervalInMilli;
        this.isAnyBetsAfterSettlement = true;
        this.redirectToDefaultGroupDelay = cmsConfig.redirectToDefaultGroupDelay;
    }
    //Todo: write tests!!
    /**
     * @function  onLogin  executed on Login of customer
     */
    MyPulseBetsData.prototype.onLogin = function () {
        this.isUserLogged = true;
        this.currencySign = this.userInfo.current.currencyCode;
        this.calculatedPeriodHelperDependency.setCurrentUserInfo(this.userInfo.current);
        this.initMyPulseBetData();
    };
    /**
     * @function  onLogout execute on Logout of customer
     */
    MyPulseBetsData.prototype.onLogout = function () {
        this.isUserLogged = false;
        this.currencySign = "";
        this.calculatedPeriodHelperDependency.setCurrentUserInfo(undefined);
        this.clearMyPulseBetData();
    };
    /**
     * @function setParams sets parameters to the store, subscribe to 'onPlayByPlayUpdate' event and starts BasePlayByPlay timer
     *
     * @param masterEventId the id of the master(main) event
     * @param branchID id of event's branch
     */
    /*istanbul ignore next */
    MyPulseBetsData.prototype.setParams = function (masterEventId, masterEventBranchId, masterEventGameTime, gameStatus, isActive) {
        var e_1, _a;
        if (!this.userInfo.current) {
            return;
        }
        if (!this.masterEvent || this.masterEvent.id !== masterEventId) {
            this.masterEvent = new MasterEventModel({
                id: masterEventId,
                branchId: masterEventBranchId,
                gameTime: masterEventGameTime,
                gameStatus: gameStatus
            });
            this.initMyPulseBetData();
        }
        else {
            this.masterEvent.gameTime = masterEventGameTime;
            if (this.masterEvent.gameStatus !== gameStatus) {
                this.masterEvent.gameStatus = gameStatus;
            }
            try {
                for (var _b = __values(this.openViewModels), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var openBet = _c.value;
                    openBet.pulseBetProgressData.expiredBetProgressInMilliseconds = (this.masterEvent.gameTime - openBet.startTimeOfBet) * 1000;
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        this.isMyPulseBetActive = isActive;
    };
    MyPulseBetsData.prototype.gameTime = function (gameTimeInSeconds) {
        var e_2, _a;
        this.masterEvent.gameTime = gameTimeInSeconds;
        try {
            for (var _b = __values(this.openViewModels), _c = _b.next(); !_c.done; _c = _b.next()) {
                var openBet = _c.value;
                openBet.pulseBetProgressData.expiredBetProgressInMilliseconds = (this.masterEvent.gameTime - openBet.startTimeOfBet) * 1000;
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    MyPulseBetsData.prototype.initMyPulseBetData = function () {
        if (this.masterEvent) {
            this.eventsManager.addEventListener("onPlayByPlayUpdate", this, this.onPlayByPlayUpdate.bind(this), true);
            this.eventsManager.addEventListener("onSuccessfullyPlacedBet", this, this.successfullyPlacedBetUpdate.bind(this), true);
            this.eventsManager.addEventListener("CurrentEventTime", this, this.gameTime.bind(this), true);
            this.provider.basePlayByPlay.startMonitor(this.masterEvent.id, this.masterEvent.branchId, this.name);
            // NOTE:
            // We convert `this.masterEvent.id` to number to match the
            // definition in legacy:
            // public static async Task<JSONValue> getOpenPulseBets(int masterEventId)
            this.provider.bettingHistoryPageMethods.getOpenPulseBets(parseInt(this.masterEvent.id, 10), this.successfulOpenPulseBetsCallback, this.errorOpenPulseBetsCallback);
            this.setUpdateOpenPulseBetsData();
        }
    };
    MyPulseBetsData.prototype.setUpdateOpenPulseBetsData = function () {
        var _this = this;
        this.updateOpenBetsTimeout = setTimeout(function () {
            // NOTE:
            // We convert `this.masterEvent.id` to number to match the
            // definition in legacy:
            // public static async Task<JSONValue> getOpenPulseBets(int masterEventId)
            _this.provider.bettingHistoryPageMethods.getOpenPulseBets(parseInt(_this.masterEvent.id, 10), _this.successfulOpenPulseBetsCallback, _this.errorOpenPulseBetsCallback);
            _this.setUpdateOpenPulseBetsData();
        }, this.updateOpenBetsInterval);
    };
    MyPulseBetsData.prototype.clearMyPulseBetData = function () {
        if (this.masterEvent) {
            this.provider.basePlayByPlay.stopMonitor(this.masterEvent.id, this.name);
            this.eventsManager.removeEventListener("onPlayByPlayUpdate", this, true);
            this.eventsManager.removeEventListener("CurrentEventTime", this, true);
            this.eventsManager.removeEventListener("onSuccessfullyPlacedBet", this, true);
        }
        clearTimeout(this.updateOpenBetsTimeout);
    };
    MyPulseBetsData.prototype.successfullyPlacedBetUpdate = function () {
        this.setDelayedOpenPulseBetsCallOnNotification();
    };
    MyPulseBetsData.prototype.setDelayedOpenPulseBetsCallOnNotification = function () {
        var _this = this;
        setTimeout(function () {
            // NOTE:
            // We convert `this.masterEvent.id` to number to match the
            // definition in legacy:
            // public static async Task<JSONValue> getOpenPulseBets(int masterEventId)
            _this.provider.bettingHistoryPageMethods.getOpenPulseBets(parseInt(_this.masterEvent.id, 10), _this.successfulOpenPulseBetsCallback, _this.errorOpenPulseBetsCallback);
        }, this.openMyPulseBetsDelay);
    };
    /*istanbul ignore next */
    MyPulseBetsData.prototype.successfulOpenPulseBetsCallback = function (response) {
        var jsonData = eval(response);
        if (jsonData) {
            for (var key in jsonData) {
                if (jsonData[key]) {
                    var openPulseBet = jsonData[key];
                    if (openPulseBet && key === "New") {
                        this.isAnyBetsAfterSettlement = true;
                        this.openViewModels = this.getPurchases(openPulseBet);
                    }
                }
            }
        }
        this.eventsManager.dispatchEvent("onUpdateMyPulseBet", this.openViewModels.length, true);
    };
    MyPulseBetsData.prototype.getWiningValueFormatted = function (viewModel, index) {
        var odds = viewModel.pulseBetMetadata.periods[index].europeanOdds;
        var stake = viewModel.stake;
        var calculatedWin = Math.floor(+(stake * odds * 100).toPrecision(12)) / 100;
        calculatedWin = viewModel.bonusInfo.isFreeBet && !viewModel.bonusInfo.isRiskFreeBet ? calculatedWin - stake : calculatedWin;
        return this.calculatedPeriodHelperDependency.formatWinnings(calculatedWin);
    };
    MyPulseBetsData.prototype.getPeriodStatus = function (qPar1, qPar2) {
        if (qPar1 < this.masterEvent.gameTime && qPar2 + qPar1 > this.masterEvent.gameTime) {
            return ProgressStatus.Current;
        }
        else if (qPar1 > this.masterEvent.gameTime) {
            return ProgressStatus.PreRun;
        }
        else if (qPar1 + qPar2 < this.masterEvent.gameTime) {
            return ProgressStatus.PostRun;
        }
        return ProgressStatus.Current;
    };
    MyPulseBetsData.prototype.getStatusClass = function (status) {
        return statusModifier[status] || "";
    };
    /*istanbul ignore next */
    MyPulseBetsData.prototype.getPurchases = function (purchases) {
        var e_3, _a;
        var parsedResponse = [];
        try {
            for (var purchases_1 = __values(purchases), purchases_1_1 = purchases_1.next(); !purchases_1_1.done; purchases_1_1 = purchases_1.next()) {
                var jsonData = purchases_1_1.value;
                var purchase = Parser.SPPurchaseParser(jsonData);
                var additionalData = new PulseBetMarketAdditionalData({
                    name: purchase.selections[0].eventTypeName,
                    branchID: "1",
                    currencySign: purchase.currencyCode,
                    durationInMilli: this.durationInMili,
                    typeId: purchase.selections[0].eventTypeId,
                    marketId: purchase.selections[0].eventId,
                    periods: this.getPeriods(purchase.selections),
                    isDanger: false
                });
                var openView = new OpenPulseBetViewModel(purchase.bets[0].deposit, purchase.bets[0].gain, additionalData, purchase.selections[0].qPar1, this.masterEvent.gameTime * 1000, purchase.purchaseId, function (inProgressData) { return false; }, function (inProgressData) { }, function (inProgressData) { }, __assign({}, this.trackColor), {
                    isFreeBet: purchase.bets[0].isFreeBet,
                    isRiskFreeBet: purchase.bets[0].isRiskFreeBet
                });
                /*istanbul ignore next */
                this.reCalculateState("", openView);
                openView.isFinished = openView.winningsData.winnings[2].winningStatus === ProgressStatus.PostRun;
                var wonSelection = purchase.selections.find(function (sel) { return sel.statusId === 2; });
                if (wonSelection) {
                    // NOTE:
                    // We convert string arguments to number to match the definition in legacy
                    openView.gain = +Math.floor(+this.oddsUtil.convertFormat(+wonSelection.odds, parseInt(wonSelection.eventTypeId, 10), 13, undefined, 1, undefined, parseInt(wonSelection.branchId, 10), undefined, undefined) * openView.stake * 100).toPrecision(12) / 100;
                    openView.finishedState = {
                        status: {
                            won: { amount: this.calculatedPeriodHelperDependency.formatWinnings(openView.gain) },
                            actions: { text: this.dict.RepeatBet, handler: function () { } }
                        }
                    };
                    openView.isFinished = true;
                    setTimeout(this.removeExpiredBet.bind(this, openView.purchaseId), this.removePulseInterval);
                }
                /*istanbul ignore next */
                openView.pulseBetProgressData = new PulseBetProgressData({
                    startTime: openView.periodFrames[0].start,
                    endTime: openView.periodFrames[2].end,
                    expiredBetProgressInMilliseconds: (this.masterEvent.gameTime - purchase.selections[0].qPar1) * 1000,
                    periods: [{
                            startTime: openView.periodFrames[0].start,
                            duration: purchase.selections[0].qPar2 + 1,
                            id: purchase.purchaseId,
                            periodNumber: 1
                        },
                        {
                            startTime: openView.periodFrames[1].start,
                            duration: purchase.selections[1].qPar2 + 1,
                            id: purchase.purchaseId,
                            periodNumber: 2
                        },
                        {
                            startTime: openView.periodFrames[2].start,
                            duration: purchase.selections[2].qPar2 + 1,
                            id: purchase.purchaseId,
                            periodNumber: 3
                        }],
                    id: purchase.purchaseId
                });
                parsedResponse.push(openView);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (purchases_1_1 && !purchases_1_1.done && (_a = purchases_1.return)) _a.call(purchases_1);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return parsedResponse;
    };
    MyPulseBetsData.prototype.reCalculateState = function (purchaseId, openviewModel) {
        var viewModel = this.openViewModels.find(function (model) { return model.purchaseId === purchaseId; });
        viewModel = viewModel || openviewModel;
        if (viewModel) {
            viewModel.winningsData = {
                winnings: [
                    {
                        winningValue: this.getWiningValueFormatted(viewModel, 0),
                        winningStatus: this.getPeriodStatus(viewModel.pulseBetMetadata.periods[0].startTimeInMilli / 1000, (viewModel.pulseBetMetadata.periods[0].endTimeInMilli - viewModel.pulseBetMetadata.periods[0].startTimeInMilli) / 1000),
                        periodNumber: 1,
                        statusClass: this.getStatusClass(this.getPeriodStatus(viewModel.pulseBetMetadata.periods[0].startTimeInMilli / 1000, (viewModel.pulseBetMetadata.periods[0].endTimeInMilli - viewModel.pulseBetMetadata.periods[0].startTimeInMilli) / 1000))
                    },
                    {
                        winningValue: this.getWiningValueFormatted(viewModel, 1),
                        winningStatus: this.getPeriodStatus(viewModel.pulseBetMetadata.periods[1].startTimeInMilli / 1000, (viewModel.pulseBetMetadata.periods[1].endTimeInMilli - viewModel.pulseBetMetadata.periods[1].startTimeInMilli) / 1000),
                        periodNumber: 2,
                        statusClass: this.getStatusClass(this.getPeriodStatus(viewModel.pulseBetMetadata.periods[1].startTimeInMilli / 1000, (viewModel.pulseBetMetadata.periods[1].endTimeInMilli - viewModel.pulseBetMetadata.periods[1].startTimeInMilli) / 1000))
                    },
                    {
                        winningValue: this.getWiningValueFormatted(viewModel, 2),
                        winningStatus: this.getPeriodStatus(viewModel.pulseBetMetadata.periods[2].startTimeInMilli / 1000, (viewModel.pulseBetMetadata.periods[2].endTimeInMilli - viewModel.pulseBetMetadata.periods[2].startTimeInMilli) / 1000),
                        periodNumber: 3,
                        statusClass: this.getStatusClass(this.getPeriodStatus(viewModel.pulseBetMetadata.periods[2].startTimeInMilli / 1000, (viewModel.pulseBetMetadata.periods[2].endTimeInMilli - viewModel.pulseBetMetadata.periods[2].startTimeInMilli) / 1000))
                    }
                ],
                branchID: this.masterEvent.branchId
            };
        }
        if (viewModel) {
            for (var i = 0; i < 3; i++) {
                var winingsPeriod = this.getPeriodStatus(viewModel.pulseBetMetadata.periods[i].startTimeInMilli / 1000, (viewModel.pulseBetMetadata.periods[i].endTimeInMilli - viewModel.pulseBetMetadata.periods[i].startTimeInMilli) / 1000);
                var winingPlusCalcInterval = this.getPeriodStatus(viewModel.pulseBetMetadata.periods[i].startTimeInMilli / 1000, (viewModel.pulseBetMetadata.periods[i].endTimeInMilli - viewModel.pulseBetMetadata.periods[i].startTimeInMilli + 3000) / 1000);
                if (winingsPeriod !== winingPlusCalcInterval) {
                    viewModel.winningsData.winnings[i].winningStatus = winingPlusCalcInterval;
                    viewModel.winningsData.winnings[i].statusClass = this.getStatusClass(winingPlusCalcInterval);
                    setTimeout(this.updateWiningStatusDebounced.bind(this, viewModel.winningsData.winnings[i]), 3000);
                }
            }
        }
    };
    MyPulseBetsData.prototype.updateWiningStatusDebounced = function (data) {
        data.winningStatus = ProgressStatus.PostRun;
        data.statusClass = this.getStatusClass(ProgressStatus);
    };
    MyPulseBetsData.prototype.updateFinishedStatusDebounced = function (data) {
        data.isFinished = true;
    };
    /*istanbul ignore next */
    MyPulseBetsData.prototype.updateWiningsStatusOnComplete = function (data) {
        var openView = this.openViewModels.find(function (model) { return model.pulseBetProgressData.id === data.id; });
        if (openView) {
            var period = openView.pulseBetProgressData.periods.find(function (prd) { return prd.periodNumber === data.periodNumber; });
            if (period) {
                if (period.periodNumber === 3) {
                    setTimeout(this.updateWiningStatusDebounced.bind(this, openView.winningsData.winnings[2]), 2000);
                    setTimeout(this.updateFinishedStatusDebounced.bind(this, openView), 6000);
                    setTimeout(this.removeExpiredBet.bind(this, openView.purchaseId), this.removePulseInterval);
                }
                else {
                    openView.winningsData.winnings[period.periodNumber].winningStatus = ProgressStatus.Current;
                    openView.winningsData.winnings[period.periodNumber].statusClass = this.getStatusClass(ProgressStatus.Current);
                    openView.winningsData.winnings[period.periodNumber - 1].winningStatus = ProgressStatus.Resulting;
                    openView.winningsData.winnings[period.periodNumber - 1].statusClass = this.getStatusClass(ProgressStatus.Resulting);
                    setTimeout(this.updateWiningStatusDebounced.bind(this, openView.winningsData.winnings[period.periodNumber - 1]), 3000);
                }
            }
        }
    };
    /*istanbul ignore next */
    MyPulseBetsData.prototype.getPeriods = function (selections) {
        var periods = [];
        for (var key = 0, keysLength = selections.length - 1; key < keysLength; key += 1) {
            if (selections[key]) {
                var selection = selections[key];
                // NOTE:
                // We convert string arguments to number to match the definition in legacy
                var formatedOdds = +this.oddsUtil.convertFormat(+selection.odds, parseInt(selection.eventTypeId, 10), 13, undefined, 1, undefined, parseInt(selection.branchId, 10), undefined, undefined);
                var selectionInfo = {
                    europeanOdds: formatedOdds,
                    startTimeInMilli: selection.qPar1 * 1000,
                    endTimeInMilli: (selection.qPar1 + selection.qPar2) * 1000
                };
                periods.push(selectionInfo);
            }
        }
        return periods;
    };
    MyPulseBetsData.prototype.errorOpenPulseBetsCallback = function () { };
    /**
     * @function deactivate is called when BaseBlock is deactivated. It removes event listeners and stops BasePlayByPlay timer
     *
     */
    MyPulseBetsData.prototype.deactivate = function () {
        this.clearMyPulseBetData();
        delete this.masterEvent;
        this.openViewModels = [];
        this.isMyPulseBetActive = false;
        this.isAnyBetsAfterSettlement = true;
        this.animationStarted = 0;
    };
    /**
     * @function onPlayByPlayUpdate is called when 'onPlayByPlayUpdate' event is dispatched in BasePlayByPlay object.
     * It filters received incidents and call getMasterEventIncidents page method
     *
     * @param parsedResponse is an array of recieved PlayByPlay incidents
     */
    /*istanbul ignore next */
    MyPulseBetsData.prototype.onPlayByPlayUpdate = function (parsedResponse) {
        var playByPlayIncidents = parsedResponse;
        var filteredIncident = this.getIncidentPerType(playByPlayIncidents, PlayByPlayIncidentTypes.Goal);
        // NOTE:
        // Definition in legacy doesn't match the new definition
        if (filteredIncident && filteredIncident.masterEventID &&
            filteredIncident.masterEventID.toString() === this.masterEvent.id) {
            this.setDelayedOpenPulseBetsCallOnNotification();
        }
    };
    /**
     * @function getIncidentPerType filters the incidents acording to a type
     *
     * @param playByPlayIncidents it's an array with all play-by-play incidents
     * @param incidentType it's the incident type which has to be filtered
     */
    MyPulseBetsData.prototype.getIncidentPerType = function (playByPlayIncidents, incidentType) {
        return playByPlayIncidents.find(function (incident) { return incident.eventStatusID === incidentType; });
    };
    /*istanbul ignore next */
    MyPulseBetsData.prototype.getPulseBetTypes = function () {
        return [
            {
                eventTypeId: PulseBetsTypes.ThirtySecPulse,
                eventTypeName: this.dict.ThirtySecPulse
            },
            {
                eventTypeId: PulseBetsTypes.OneMinPulse,
                eventTypeName: this.dict.OneMinPulse
            },
            {
                eventTypeId: PulseBetsTypes.FiveMinPulse,
                eventTypeName: this.dict.FiveMinPulse
            },
            {
                eventTypeId: PulseBetsTypes.TenMinPulse,
                eventTypeName: this.dict.TenMinPulse
            },
        ];
    };
    /*istanbul ignore next */
    MyPulseBetsData.prototype.removeExpiredBet = function (purchaseId) {
        var _this = this;
        var indexToRemove = this.openViewModels.findIndex(function (openBet) { return openBet.purchaseId === purchaseId; });
        if (indexToRemove !== -1) {
            this.openViewModels.splice(indexToRemove, 1);
            if (!this.openViewModels.length) {
                this.isAnyBetsAfterSettlement = false;
                setTimeout(function () {
                    _this.eventsManager.dispatchEvent("onUpdateMyPulseBet", _this.openViewModels.length, true);
                    _this.isAnyBetsAfterSettlement = true;
                }, this.redirectToDefaultGroupDelay);
            }
            else {
                this.eventsManager.dispatchEvent("onUpdateMyPulseBet", this.openViewModels.length, true);
            }
        }
    };
    Object.defineProperty(MyPulseBetsData.prototype, "isGameRunning", {
        get: function () {
            return this.masterEvent.gameStatus === GameStatuses.FirstHalf || this.masterEvent.gameStatus === GameStatuses.SecondHalf;
        },
        enumerable: true,
        configurable: true
    });
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], MyPulseBetsData.prototype, "isUserLogged", void 0);
    __decorate([
        observable,
        __metadata("design:type", String)
    ], MyPulseBetsData.prototype, "currencySign", void 0);
    __decorate([
        observable,
        __metadata("design:type", Array)
    ], MyPulseBetsData.prototype, "openViewModels", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], MyPulseBetsData.prototype, "isMyPulseBetActive", void 0);
    __decorate([
        observable,
        __metadata("design:type", Boolean)
    ], MyPulseBetsData.prototype, "isAnyBetsAfterSettlement", void 0);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MyPulseBetsData.prototype, "onLogin", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", []),
        __metadata("design:returntype", void 0)
    ], MyPulseBetsData.prototype, "onLogout", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, String, Number, Number, Boolean]),
        __metadata("design:returntype", void 0)
    ], MyPulseBetsData.prototype, "setParams", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], MyPulseBetsData.prototype, "successfulOpenPulseBetsCallback", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String, OpenPulseBetViewModel]),
        __metadata("design:returntype", void 0)
    ], MyPulseBetsData.prototype, "reCalculateState", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [WinningDataInner]),
        __metadata("design:returntype", void 0)
    ], MyPulseBetsData.prototype, "updateWiningStatusDebounced", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [OpenPulseBetViewModel]),
        __metadata("design:returntype", void 0)
    ], MyPulseBetsData.prototype, "updateFinishedStatusDebounced", null);
    __decorate([
        action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [PulseBetProgressPeriodData]),
        __metadata("design:returntype", void 0)
    ], MyPulseBetsData.prototype, "updateWiningsStatusOnComplete", null);
    __decorate([
        action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [String]),
        __metadata("design:returntype", void 0)
    ], MyPulseBetsData.prototype, "removeExpiredBet", null);
    __decorate([
        computed,
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], MyPulseBetsData.prototype, "isGameRunning", null);
    return MyPulseBetsData;
}());
export { MyPulseBetsData };
;
//# sourceMappingURL=MyPulseBetsData.js.map